import React from 'react';
import PropTypes from 'prop-types';
import './SideMenu.scss';
import { Link,useStaticQuery ,graphql} from "gatsby";

export const SideMenu = () => {
  const postData = useStaticQuery(graphql`
    query {
      allMarkdownRemark(sort: {order: DESC, fields: frontmatter___startDate }) {
        edges {
          node {
            id
            frontmatter {
              title
              startDate
              thumbnail {
                name
              }
            }
          }
        }
      }
    }
  `);

  return (
    <div className="side-menu">
      <ul className="side-menu-list">
        <li className="side-menu-list-content">
          <Link to="/" className="side-menu-link">
            TOP
          </Link>
        </li>
        <li className="side-menu-list-content">
          <p className="side-menu-link">
            EVENTS
          </p>
          <ul className="sub-menu-list">
            {
              postData.allMarkdownRemark.edges.map(d => {
                const title = d.node.frontmatter.title;
                return (
                  <li className="sub-menu-list-content">
                    <a href={d.node.id}>
                      {title}
                    </a>
                  </li>
                  );
              })
            }
          </ul>
        </li>
        <li className="side-menu-list-content">
          <Link to="https://docs.google.com/forms/d/e/1FAIpQLSdcPXB2Aoi2YCT3UwfXJege6jxt--rIEdaiUNpUHXcDBS5pEg/viewform?usp=sf_link" target="_blank" className="side-menu-link">
            出店申込
          </Link>
        </li>
        <li className="side-menu-list-content">
          <Link to="/tos" className="side-menu-link">
            出店規約
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SideMenu;
